import { composeCouponRouteTemplate } from '@/lib/coupon/gen-code'
import { DEFAULT_POS_PERCENTAGE_COUPON } from '@/providers/coupon/PosPercentageProvider'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/coupon/pos-percentage')(
  composeCouponRouteTemplate(DEFAULT_POS_PERCENTAGE_COUPON),
)
